import React from 'react';
import { ShieldCheck } from 'lucide-react';

export default function CryptoBadge({ userProfile, className = "w-12 h-12" }) {
  // Extract the first letter of the email, or default to a secure fallback
  const initial = userProfile?.email?.charAt(0).toUpperCase() || 'V';

  return (
    <div className={`relative overflow-hidden rounded-full bg-slate-900 shadow-inner flex items-center justify-center border-2 border-slate-700 ${className}`}>
      <span className="font-mono font-black text-slate-200" style={{ fontSize: '45%' }}>
        {initial}
      </span>
      {/* Verification Checkmark Overlay */}
      <div className="absolute bottom-0 right-0 w-1/3 h-1/3 bg-emerald-500 rounded-full border-2 border-slate-900 flex items-center justify-center" title="Verified Origin">
        <ShieldCheck className="text-slate-900" style={{ width: '80%', height: '80%' }} />
      </div>
    </div>
  );
}